module.exports = __webpack_public_path__ + "53955f1b3242226a69930d949f46f8a0.svg";